module.exports = __webpack_public_path__ + "media/corporate-image/tachikawalogo-whiiteback-b29e2a28681489de4a4520ffbc9eee9a.png";